import Keycloak from 'keycloak-js';

import { env } from './env';

declare global {
  var __keycloak__: Keycloak | undefined;
  interface Window {
    keycloakConfig?: {
      url: string;
      realm: string;
      clientId: string;
    };
  }
}

// Expose config to popup windows
window.keycloakConfig = {
  url: env.VITE_KEYCLOAK_URL,
  realm: 'ics',
  clientId: 'react-client',
};

export const keycloak =
  globalThis.__keycloak__ ?? (globalThis.__keycloak__ = new Keycloak(window.keycloakConfig));
